import Vue from 'vue'
import Router from 'vue-router'
import store from "@mobile/store";
import Login from "@mobile/components/login/Manager";
import Register from "@mobile/components/register/Manager";
import Simple from "@components/layouts/Simple";
import Basic from "@components/layouts/Basic";
import ProjectsView from "@components/projects/View";
import ProjectsIndex from "@components/projects/Index";
import FilesIndex from "@components/files/Index";
import ReportsIndex from "@components/reports/Index";
import ReportEdit from "@components/reports/Edit";
import CompanyUsers from "@components/users/CompanyUsers";
import ProjectUsers from "@components/users/ProjectUsers";
import MarkingsIndex from "@components/markings/Index";
import UnderConstruction from "@components/site-design/Index";
import SiteToolsIndex from "@components/site-tools/Index";
import ProductsIndex from "@components/products/Index";
import Account from "@components/account/Account";
import CompanyDetails from "@components/company/Index";
import SubscriptionsIndex from "@components/subscriptions/Index";
import ForgotPassword from "../components/common/ForgotPassword";

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    linkActiveClass: 'active',
    routes: [
        {
            path: '/login/:force?',
            name: 'Login',
            component: Login,
            meta: {
                title: 'Login',
                backButtonRoute: false
            }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: {
                title: 'Register',
                backButtonRoute: 'Login'
            }
        },
        {
            path: '/forgot-password',
            name: 'ForgotPassword',
            component: ForgotPassword,
            meta: {
                title: 'Forgot Password',
                backButtonRoute: 'Login'
            }
        },
        {
            path: '',
            component: Simple,
            meta: {},
            children: [
                {
                    path: '/',
                    name: 'projects-index',
                    component: ProjectsIndex,
                    meta: {
                        title: 'Projects',
                        requiresAuth: true
                    },
                }
            ]
        },
        {
            path: '',
            component: Basic,
            meta: {},
            children: [
                {
                    path: '/projects/:id',
                    name: 'projects-view',
                    component: ProjectsView,
                    meta: {
                        title: 'Dashboard',
                        requiresAuth: true
                    },
                },
                {
                    path: 'companies/:company_id/users',
                    name: 'company-users-index',
                    component: CompanyUsers,
                    meta: {
                        title: 'Company Users',
                        requiresAuth: true,
                        adminMenu: true
                    },
                },
                {
                    path: 'companies/:company_id/account',
                    name: 'account',
                    component: Account,
                    meta: {
                        title: 'My Account',
                        requiresAuth: true,
                        adminMenu: true
                    },
                },
                {
                    path: 'companies/:company_id/details',
                    name: 'company-details',
                    component: CompanyDetails,
                    meta: {
                        title: 'Company Details',
                        requiresAuth: true,
                        adminMenu: true
                    },
                },
                // {
                //     path: '/companies/:company_id/subscriptions',
                //     name: 'subscriptions-index',
                //     component: SubscriptionsIndex,
                //     meta: {
                //         title: 'Subscriptions',
                //         requiresAuth: true,
                //         adminMenu: true
                //     },
                // },
                {
                    path: '/projects/:id/site-design',
                    name: 'site-design-index',
                    component: UnderConstruction,
                    meta: {
                        title: 'Site design',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/site-tools',
                    name: 'site-tools-index',
                    component: SiteToolsIndex,
                    meta: {
                        title: 'Site tools',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/users',
                    name: 'project-users-index',
                    component: ProjectUsers,
                    meta: {
                        title: 'Project Users',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/files',
                    name: 'projects-files-index',
                    component: FilesIndex,
                    meta: {
                        title: 'Files',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/reports',
                    name: 'projects-reports-index',
                    component: ReportsIndex,
                    meta: {
                        title: 'Reports',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/reports/:report_id',
                    name: 'projects-reports-view',
                    component: ReportsIndex,
                    meta: {
                        title: 'Reports',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/reports/:report_id/edit',
                    name: 'projects-report-edit-view',
                    component: ReportEdit,
                    meta: {
                        title: 'Edit Report',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/files/:file_id/edit',
                    name: 'projects-file-edit-view',
                    component: ReportEdit,
                    alias: 'projects-report-edit-view',
                    meta: {
                        title: 'Create Report',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/files/:file_id/users/:user_id/edit',
                    name: 'projects-file-user-edit-view',
                    component: ReportEdit,
                    alias: 'projects-report-edit-view',
                    meta: {
                        title: 'Create Report',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/markings',
                    name: 'projects-markings-index',
                    component: MarkingsIndex,
                    meta: {
                        title: 'Site monitoring',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/markings/:file_id',
                    name: 'projects-markings-view',
                    component: MarkingsIndex,
                    meta: {
                        title: 'Site monitoring',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/markings/:file_id/users/:user_id',
                    name: 'projects-markings-users-view',
                    component: MarkingsIndex,
                    meta: {
                        title: 'Site monitoring',
                        requiresAuth: true
                    },
                },
                {
                    path: '/projects/:id/products',
                    name: 'projects-products',
                    component: ProductsIndex,
                    meta: {
                        title: 'Products',
                        requiresAuth: true
                    },
                },
            ]
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next()
            return
        }
        next('/login')
    } else {
        next()
    }
});

export default router;
